












import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      user: {
        name: '',
      },
    };
  },
  created() {
    const user = this.getUser();
    if (user === null) {
      return;
    }
    this.user = user;
  },
  methods: {
    ...mapGetters(['getUser']),
  },
};
